/*
Rajesh 09/19/2022 2699250881 Fixed GAL (136,137,158,98) and field group table GAL-153
Sohel  09/22/2022 2699250881 Custom Windows Feedback Modifications
Sohel  09/23/2022 2699250881 Fixed Custom Windows Feedback Changes
Ashraf 09/24/2022 2699250881 Fixed Custom Windows Bugs
Ashraf 09/24/2022 2699250881 drag and drop custom fields
Ashraf 09/25/2022 2699250881 custom window fields drag and drop bug fixes
Ashraf 09/25/2022 2699250881 removed commented code.
Poornima 09/27/2022 2699250881 Fixed GAL-132 sequence number search issues.
Aditya 09/29/2022 2699250881 Minor changes
Aditya 09/29/2022 2699250881 Minor changes
Ashraf 09/29/2022 2699250881 fixed bugs on add custom window
Ashraf 09/29/2022 2699250881 fixed style issues in custom windows
Ashraf 09/30/2022 2699250881 fixed ssn and phone format bugs
Raghuarun 09/30/2022 2699250881 Alignments in custom window table
Ashraf 09/30/2022 2699250881 fixed copy window issue
Rajesh 10/01/2022 2699250881 fixed bugs in UDW
Ashraf 10/01/2022 2699250881 disabled add button based on role in custom windows
Ashraf 10/06/2022 2699250881 fixed page break issue in role data
Ashraf 10/06/2022 2699250881 added comments to code, removed unusual code
Asharf 10/12/2022 2699250881 fixed communication history bugs
Ashraf 10/15/2022 2699250881 Added custom windows code comments.
suresh peddavoora 10/27/2022 2699250881 Added Class Name for Table Enhancements
Ashraf 10/30/2022 2699250881 fixed table pagination issue
saikrishna 11/03/2022 2699250881 Changed pagination options
Ashraf 11/09/2022 2699250881 Added dropdown values for custom search.

*/
import React, {useEffect, useState} from 'react';
import {MTableBody, MTableBodyRow} from 'material-table';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import DialogBox from '../../../components/DialogBox';
import Form from './Form';
import {tableIcons} from '../../TableIcons';
import DeleteForm from './DeleteForm';
import {
  resetToast,
  FieldDeletionCheck as fieldDeletionCheck,
  resetUdwStatus,
} from '../../../redux/reducers/UserDefinedWindow';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../PageLoader';
import {SuccessSnackbar} from '../../CustomSnackBar';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import {Button, TablePagination} from '@material-ui/core';
import {getUDW} from '../../../redux/reducers/UserDefinedWindow';
import {tablePageRows, defaultRows} from '../../../constants/ReusableConstants';
import AddIcon from '@material-ui/icons/Add';
import inputStyles from '../../../components/InputStyles';
import {resetDbRefData} from '../../../redux/reducers/UserDefinedWindow';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {makeStyles} from '@material-ui/styles';
import GuiTable from '../../FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
const useStyles = makeStyles({
  letterTable: {
    '& .MuiTableRow-root': {
      color: 'inherit',
      display: 'inherit',
      outline: 0,
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root': {
      display: 'inherit',
      textAlign: 'center',
    },
    '& .MuiTableSortLabel-root > div': {
      fontSize: '0.790rem !important',
      fontWeight: 'bold !important',
    },
  }});

// fields table, add field dialog component render (2699250881)

export default function Fields({
  UDWData,
  formData,
  setFormData,
  windowNumber,
  udwView,
  isCopyRowData,
  editable,
  setEditable,
  setDeletedFields,
  deletedFields,
  editExisting,
  reset,
  deleted,
  setDeleted,
  initialValues,
  setEditExisting,
  changedWindowNumber,
  setLookupValuesData,
  dirty,
}) {
  const {
    isLoading,
    errorMsg,
    successMsg,
    udwData,
    fieldDeleteStatus,
    fieldDeleteFromDBStatus,
    fieldDeleteFromDBMessage,
    fieldDeletionLoading,
  } = useSelector(({userDefinedWindow}) => userDefinedWindow);

  // fetching window details based on window number (2699250881)
  useEffect(() => {
    if (windowNumber) {
      dispatch(getUDW(windowNumber));
    }
  }, [windowNumber, changedWindowNumber]);

  const classes1 = useStyles();
  const classes = inputStyles();
  const dispatch = useDispatch();

  // reset redux state after error or success message (2699250881)
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetToast());
      }, 4000);
    }
  }, [errorMsg, successMsg, dispatch]);

  // reset redux state after field deletion (2699250881)
  useEffect(() => {
    if (fieldDeleteStatus) {
      setTimeout(() => {
        dispatch(resetToast());
        dispatch(resetUdwStatus());
      }, 3000);
    }
  }, [fieldDeleteStatus]);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [field, setField] = useState('');
  const [dbRef, setDBRef] = useState({});
  const [oldFieldName, setOldFieldName] = useState();
  const [fieldOperation, setFieldOperation] = useState();
  const [maxSequence, setMaxSequence] = useState();
  const [rowData, setRowData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [windowData, setWindowData] = useState([]);
  const [windowId, setWindowId] = useState();
  const [rows, setRows] = useState(defaultRows);

  // setting table data after fetching (2699250881)
  useEffect(() => {
    if (udwData && Object.keys(udwData).length > 0 && udwData?.[windowNumber]?.fields) {
      setWindowData(udwData?.[windowNumber]?.fields);
    } else if (udwData && Object.keys(udwData).length > 0 && udwData?.[windowNumber]) {
      setWindowData([]);
    } else {
      setWindowData(formData);
    }
  }, [udwData, windowNumber]);

  // setting table data after fetching for editing window number (2699250881)
  useEffect(() => {
    if (windowData && windowData.length > 0) {
      let editData = [];
      editData = windowData.map((o, i) => ({
        windowFieldId: o?.windowFieldId,
        sequenceNo: o?.sequenceNo ? o?.sequenceNo : '',
        fieldLabel: o?.fieldLabel,
        fieldType: o?.fieldType,
        fieldName: o?.fieldName,
        validationType: o?.validationType ? o?.validationType : null,
        lookupType: o?.lookupType ? o?.lookupType : '',
        isLookUp: o?.isLookUp ? o?.isLookUp : false,
        isActive: o?.isActive ? o?.isActive : 'Y',
        isList: o?.isList,
        fieldOperation: 'N',
        oldFieldName: '',
        listValue: o?.isList?.toLowerCase() === 'dropdown' ? '' : o?.listValue ? o?.listValue : '',
        isMandatory: o?.isMandatory,
        typeCode: o?.isList?.toLowerCase() === 'dropdown' ? o?.listValue?.toString() : '',
        validations: o?.validations,
        globalFieldName: o?.globalFieldName ? o?.globalFieldName : '',
        maximumLength: o?.maximumLength ? o?.maximumLength : '',
        minimumLength: o?.minimumLength ? o?.minimumLength : '',
        displayOptions: {
          isExtended: o?.isExtended,
          isEditable: o?.isEditable,
          isUnique: o?.isUnique,
          isHidden: o?.isHidden,
        },
        additionalOptions: {
          isAuditNote: o?.isAuditNote,
          isAuditTrail: o?.isAuditTrail,
          isTrackChanges: o?.isTrackChanges,
        },
      }));
      if (deleted && deleted?.length > 0) {
        const ids = deleted.map((o) => o.windowFieldId);
        const filtered = editData.filter((item, index) => {
          if (ids.includes(item?.windowFieldId)) {
            return;
          } else {
            return item;
          }
        });
        setEditable(filtered);
      } else {
        setEditable(editData?.length > 0 ? editData : []);
      }
      setWindowId(editData[0].windowId);
    } else {
      setEditable([]);
    }
  }, [windowData, reset]);

  // handling form data of field for edit (2699256862)
  const handleEdit = (data) => {
    setRowData(data);
    setIsEditMode(true);
    editExisting && data?.windowFieldId && setOldFieldName(data?.fieldName);
    setIsEditOpen(true);
    setEditData(data);
    setField(data?.fieldType);
    setDBRef(data?.globalFieldName);
  };

  // handling data of field for delete (2699256862)
  const handleDelete = (data) => {
    editExisting && delete data.windowId;
    setDeleteData(data);
    data?.windowFieldId &&
      dispatch(
        fieldDeletionCheck({
          tableFieldName: data?.fieldName ? data?.fieldName : '',
          tableName: initialValues?.dbTableView ? initialValues?.dbTableView : '',
          fieldType: data?.fieldType ? data?.fieldType : '',
          fieldLabel: data?.fieldLabel ? data?.fieldLabel : '',
        }),
      );
  };

  // reset delete data after window number change (2699256862)
  useEffect(() => {
    setDeleteData([]);
    setDeletedFields({});
    setDeleted([]);
  }, [windowNumber]);

  // show delete popup if validation status is 200 (2699256862)
  useEffect(() => {
    if (fieldDeleteStatus === 200) {
      setIsDeleteOpen(true);
    }
  }, [fieldDeleteStatus]);

  // reset status after successfully deleting a field (2699256862)
  useEffect(() => {
    if (fieldDeleteFromDBStatus === 200) {
      handleDeleteSubmit();
      setTimeout(() => {
        dispatch(resetToast());
        dispatch(resetUdwStatus());
      }, 2000);
    }
  }, [fieldDeleteFromDBStatus]);

  // showing delete popup without db check for new fields (2699256862)
  useEffect(() => {
    if (!deleteData?.windowFieldId) {
      Object.keys(deleteData)?.length > 0 && setIsDeleteOpen(true);
    }
  }, [deleteData]);


  const {roleData} = useSelector(({role}) => role);

  // reset if window number is null (2699256862)
  useEffect(() => {
    if (!windowNumber) {
      setEditable([]);
      setFormData([]);
      setWindowId('');
    }
  }, [windowNumber]);

  // used for custom search for table columns (2699250881)
  const getValue = (validations, type) => {
    const item =
      validations && validations.length > 0 && validations.filter((i) => i.type === type);
    if (item && item.length > 0 && item[0].params && item[0].params.length > 0) {
      return item[0].params[0];
    }
  };

  // handling table data for deletion of field (2699256862)
  const handleDeleteSubmit = () => {
    if (windowNumber && editExisting) {
      const filterDelete = editable.filter(
        (item) => item.tableData.id !== deleteData?.tableData?.id,
      );
      if (!deleteData?.windowFieldId) {
        setEditable(filterDelete);
      }
      if (deleteData?.windowFieldId) {
        setEditable(filterDelete);
        const obj = {};
        setDeletedFields(obj);
      }
    } else {
      const filteredData = formData.filter((item) => item.sequenceNo !== deleteData.sequenceNo);
      const filter = filteredData.filter((item) =>{
        if (deleteData.sequenceNo < item.sequenceNo) {
          return  item.sequenceNo -= 1;
        } else{
          return item.sequenceNo;
        }
      });
      setFormData(filter);
    }
    setDeleteData({});
  };

  // add field dialog box close (2699256862)
  const handleClose = () => {
    dispatch(resetDbRefData());
    setIsAddOpen(false);
    setIsEditOpen(false);
    setIsDeleteOpen(false);
    setEditData({});
    setIsEditMode(false);
    editData['fieldType'] = field;
    editData['globalFieldName'] = dbRef;
  };

  // delete popup close (2699256862)
  const handleClearDeletion = () => {
    setIsAddOpen(false);
    setIsEditOpen(false);
    setIsDeleteOpen(false);
    setEditData({});
    setIsEditMode(false);
    setDeleteData({});
  };

  // initial columns for fields table (2699250881)
  const coloumns = [
    {
      title: 'Sequence No',
      render: (rowData) => {
        const rowSeqNo =
          rowData?.tableData?.id === 0 ?
            1 :
            rowData?.tableData?.id ?
              rowData?.tableData?.id + 1 :
              '';
        if (windowNumber && !isCopyRowData && editable?.length > 0) {
          editable[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        } else if ((isCopyRowData || !windowNumber) && formData?.length > 0) {
          formData[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        }
      },
      customFilterAndSearch: (term, rowData) => {
        return rowData?.sequenceNo?.toString()?.indexOf(term) > -1;
      },
    },
    {title: 'Field Label', field: 'fieldLabel'},
    {
      title: 'Field Type',
      field: 'fieldType',
      customFilterAndSearch: (term, rowData) => {
        return (
          (rowData?.fieldType === 'string' &&
            rowData?.isList !== 'Y' &&
            'text'?.toString()?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.isList == 'Y' && 'dropdown'?.indexOf(term) > -1) ||
          (rowData?.fieldType !== 'string' &&
            rowData?.fieldType?.toLowerCase()?.indexOf(term.toLowerCase()) > -1)
        );
      },
      render: ({fieldType, isList}) => (
        <>{isList == 'Y' || isList == 'Dropdown' ? 'Dropdown' : fieldType === 'string' ? 'Text' : fieldType}</>
      ),
    },
    {
      title: 'Minimum',
      field: 'minimum',
      type: 'numeric',
      customFilterAndSearch: (term, rowData) => {
        return getValue(rowData?.validations, 'min')?.toString()?.indexOf(term) > -1;
      },
      render: ({validations, fieldType}) =>
        getValue(validations, 'min') && fieldType === 'Amount' ?
          new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2,
          }).format(getValue(validations, 'min')) :
          getValue(validations, 'min'),
    },
    {
      title: 'Maximum',
      field: 'maximum',
      type: 'numeric',
      customFilterAndSearch: (term, rowData) => {
        return getValue(rowData?.validations, 'max')?.toString()?.indexOf(term) > -1;
      },
      render: ({validations, fieldType}) =>
        getValue(validations, 'max') && fieldType === 'Amount' ?
          new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2,
          }).format(getValue(validations, 'max')) :
          getValue(validations, 'max'),
    },
    {
      title: 'Mandatory',
      field: 'isMandatory',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: (rowData) =>
        rowData?.isMandatory === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Is Lookup',
      field: 'isLookUp',
      render: (rowData) =>
        rowData?.isLookUp === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Lookup',
      field: 'lookupType',
    },
    {
      title: 'View Only',
      field: 'isEditable',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({displayOptions}) =>
        displayOptions?.isEditable === 'N' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Audit Trail',
      field: 'isAuditTrail',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({additionalOptions}) =>
        additionalOptions?.isAuditTrail === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Audit Note',
      field: 'isAuditNote',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({additionalOptions}) =>
        additionalOptions?.isAuditNote === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Unique',
      field: 'isUnique',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: ({displayOptions}) =>
        displayOptions?.isUnique === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'IsActive',
      field: 'isActive',
      hidden: true,
    },
  ];

  // view only window columns for fields table (2699250881)
  const viewOnlyColoumns = [
    {
      title: 'Sequence No',
      render: (rowData) => {
        const rowSeqNo =
          rowData?.tableData?.id === 0 ?
            1 :
            rowData?.tableData?.id ?
              rowData?.tableData?.id + 1 :
              '';
        if (windowNumber && !isCopyRowData && editable?.length > 0) {
          editable[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        } else if ((isCopyRowData || !windowNumber) && formData?.length > 0) {
          formData[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        }
      },
      customFilterAndSearch: (term, rowData) => {
        return rowData?.sequenceNo?.toString()?.indexOf(term) > -1;
      },
    },
    {title: 'Field Label', field: 'fieldLabel'},
    {
      title: 'Field Type',
      field: 'fieldType',
      customFilterAndSearch: (term, rowData) => {
        return (
          (rowData?.fieldType === 'string' &&
            rowData?.isList !== 'Y' &&
            'text'?.toString()?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.isList == 'Y' && 'dropdown'?.indexOf(term) > -1) ||
          (rowData?.fieldType !== 'string' &&
            rowData?.fieldType?.toLowerCase()?.indexOf(term.toLowerCase()) > -1)
        );
      },
      render: ({fieldType, isList}) => (
        <>{isList == 'Y' || isList == 'Dropdown' ? 'Dropdown' : fieldType === 'string' ? 'Text' : fieldType}</>
      ),
    },

    {
      title: 'Is Lookup',
      field: 'isLookup',
      render: (rowData) =>
        rowData?.isLookUp === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Lookup',
      field: 'lookupType',
    },
  ];

  // view only window columns for fields table (2699250881)
  const viewOnlyColoumns2 = [
    {
      title: 'Sequence No',
      render: (rowData) => {
        const rowSeqNo =
          rowData?.tableData?.id === 0 ?
            1 :
            rowData?.tableData?.id ?
              rowData?.tableData?.id + 1 :
              '';
        if (windowNumber && !isCopyRowData && editable?.length > 0) {
          editable[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        } else if ((isCopyRowData || !windowNumber) && formData?.length > 0) {
          formData[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        }
      },
      customFilterAndSearch: (term, rowData) => {
        return rowData?.sequenceNo?.toString()?.indexOf(term) > -1;
      },
    },
    {title: 'Field Label', field: 'fieldLabel'},
    {
      title: 'Field Type',
      field: 'fieldType',
      customFilterAndSearch: (term, rowData) => {
        return (
          (rowData?.fieldType === 'string' &&
            rowData?.isList !== 'Y' &&
            'text'?.toString()?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.isList == 'Y' && 'dropdown'?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.fieldType !== 'string' && rowData?.fieldType?.toLowerCase()?.indexOf(term) > -1)
        );
      },
      render: ({fieldType, isList}) => (
        <>{isList == 'Y' || isList == 'Dropdown' ? 'Dropdown' : fieldType === 'string' ? 'Text' : fieldType}</>
      ),
    },
    {
      title: 'Is Lookup',
      field: 'isLookup',
      render: (rowData) =>
        rowData?.isLookUp === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Lookup',
      field: 'lookupType',
    },
  ];

  // editing existing window columns for fields table (2699250881)
  const coloumns2 = [
    {
      title: 'Sequence No',
      render: (rowData) => {
        const rowSeqNo =
          rowData?.tableData?.id === 0 ?
            1 :
            rowData?.tableData?.id ?
              rowData?.tableData?.id + 1 :
              '';
        if (windowNumber && !isCopyRowData && editable?.length > 0) {
          editable[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        } else if ((isCopyRowData || !windowNumber) && formData?.length > 0) {
          formData[rowData?.tableData?.id].sequenceNo = rowSeqNo;
          return rowSeqNo;
        }
      },
      customFilterAndSearch: (term, rowData) => {
        return rowData?.sequenceNo?.toString()?.indexOf(term) > -1;
      },
    },
    {title: 'Field Label', field: 'fieldLabel'},
    {
      title: 'Field Type',
      field: 'fieldType',
      render: ({fieldType, isList}) => (
        <>{isList == 'Y' || isList == 'Dropdown' ? 'Dropdown' : fieldType === 'string' ? 'Text' : fieldType}</>
      ),
      customFilterAndSearch: (term, rowData) => {
        return (
          (rowData?.fieldType === 'string' &&
            rowData?.isList !== 'Y' &&
            'text'?.toString()?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.isList == 'Y' && 'dropdown'?.indexOf(term.toLowerCase()) > -1) ||
          (rowData?.fieldType !== 'string' &&
            rowData?.fieldType?.toLowerCase()?.indexOf(term.toLowerCase()) > -1)
        );
      },
    },
    {
      title: 'Minimum',
      field: 'minimum',
      type: 'numeric',
      customFilterAndSearch: (term, rowData) => {
        return getValue(rowData?.validations, 'min')?.toString()?.indexOf(term) > -1;
      },
      render: ({validations, fieldType}) =>
        getValue(validations, 'min') && fieldType === 'Amount' ?
          new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2,
          }).format(getValue(validations, 'min')) :
          getValue(validations, 'min'),
    },
    {
      title: 'Maximum',
      field: 'maximum',
      type: 'numeric',
      customFilterAndSearch: (term, rowData) => {
        return getValue(rowData?.validations, 'max')?.toString()?.indexOf(term) > -1;
      },
      render: ({validations, fieldType}) =>
        getValue(validations, 'max') && fieldType === 'Amount' ?
          new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2,
          }).format(getValue(validations, 'max')) :
          getValue(validations, 'max'),
    },
    {
      title: 'Mandatory',
      field: 'isMandatory',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.isMandatory?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: (rowData) =>
        rowData.isMandatory === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },

    {
      title: 'Is Lookup',
      field: 'isLookup',
      render: (rowData) =>
        rowData?.isLookUp === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'Lookup',
      field: 'lookupType',
    },
    {
      title: 'View Only',
      field: 'isEditable',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.displayOptions?.isEditable?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: (rowData) =>
        rowData?.displayOptions?.isEditable === 'N' ? <CheckOutlinedIcon color="secondary" /> : '',
    },

    {
      title: 'Audit Trail',
      field: 'isAuditTrail',
      customFilterAndSearch: (term, rowData) => {
        if (
          rowData?.additionalOptions?.isAuditTrail?.toLowerCase()?.indexOf(term.toLowerCase()) > -1
        ) {
          return;
        }
      },
      render: (rowData) =>
        rowData?.additionalOptions?.isAuditTrail === 'Y' ? (
          <CheckOutlinedIcon color="secondary" />
        ) : (
          ''
        ),
    },
    {
      title: 'Audit Note',
      field: 'isAuditNote',
      customFilterAndSearch: (term, rowData) => {
        if (
          rowData?.additionalOptions?.isAuditNote?.toLowerCase()?.indexOf(term.toLowerCase()) > -1
        ) {
          return;
        }
      },
      render: (rowData) =>
        rowData?.additionalOptions?.isAuditNote === 'Y' ? (
          <CheckOutlinedIcon color="secondary" />
        ) : (
          ''
        ),
    },
    {
      title: 'Unique',
      field: 'isUnique',
      customFilterAndSearch: (term, rowData) => {
        if (rowData?.displayOptions?.isUnique?.toLowerCase()?.indexOf(term.toLowerCase()) > -1) {
          return;
        }
      },
      render: (rowData) =>
        rowData?.displayOptions?.isUnique === 'Y' ? <CheckOutlinedIcon color="secondary" /> : '',
    },
    {
      title: 'IsActive',
      field: 'isActive',
      hidden: true,
    },
  ];

  // on drag end for a field, rearranges rows (2699256862)
  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (isCopyRowData || !windowNumber) {
      if (source.index !== destination.index) {
        const copyRows = [...formData];
        const temp = formData[source.index];
        copyRows.splice(source.index, 1);
        copyRows.splice(destination.index, 0, temp);
        setFormData(copyRows);
      }
    } else if (windowNumber) {
      if (source.index !== destination.index) {
        const copyRows = [...editable];
        const temp = editable[source.index];
        copyRows.splice(source.index, 1);
        copyRows.splice(destination.index, 0, temp);
        setEditable(copyRows);
      }
    }
  };
  useEffect(() => {
    setTimeout(() => {
      document && document?.getElementById('table-mat')?.click();
    }, 500);
  }, [editable]);

  return (
    <>
      <DialogBox
        title={isAddOpen ? 'Add Fields' : isEditOpen ? 'Edit Field' : ''}
        open={isAddOpen || isEditOpen}
        dialogClose={handleClose}
        maxWidth="md"
      >
        <Form
          handleClose={handleClose}
          setFormData={setFormData}
          formData={formData}
          udwView={udwView}
          dbRef={dbRef}
          data={editData}
          editable={editable}
          setEditable={setEditable}
          windowId={windowId}
          field={field}
          isEditMode={isEditMode}
          rowData={rowData}
          isAddOpen={isAddOpen}
          isEditOpen={isEditOpen}
          oldFieldName={oldFieldName}
          fieldOperation={fieldOperation}
          maxSequence={maxSequence}
          windowNumber={windowNumber}
          isCopyRowData={isCopyRowData}
          editExisting={editExisting}
          setMaxSequence={setMaxSequence}
          setFieldOperation={setFieldOperation}
          setOldFieldName={setOldFieldName}
        />
      </DialogBox>
      <DialogBox title="Delete Field" open={isDeleteOpen} dialogClose={handleClearDeletion}>
        <DeleteForm
          setDeleteData={setDeleteData}
          handleClose={handleClose}
          deleteData={deleteData}
          handleDeleteSubmit={handleDeleteSubmit}
          data={editData}
          setOldFieldName={setOldFieldName}
          initialValues={initialValues}
          setFieldOperation={setFieldOperation}
        />
      </DialogBox>
      <div
        id="table-mat"
        className={`${classes1.letterTable} custom-window-table drag-and-drop-table custom-actions-icon custom-toolbar-icons global-field-table`}
      >
        <GuiTable
          title=""
          icons={tableIcons}
          columns={
            windowNumber && udwView && !isCopyRowData ?
              viewOnlyColoumns2 :
              windowNumber && !udwView && !isCopyRowData ?
                coloumns2 :
                (!windowNumber && udwView) || (windowNumber && udwView && isCopyRowData) ?
                  viewOnlyColoumns :
                  coloumns
          }
          data={isCopyRowData ? formData : windowNumber && !isCopyRowData ? editable : formData}
          isLoading={fieldDeletionLoading}
          options={{
            pageSizeOptions: tablePageRows,
            pageSize: rows,
            search: false,
            emptyRowsWhenPaging: false,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              // Added Rows per screen text in Table pagination (2700780638)
              <TablePagination
                {...props}
                SelectProps={{
                  inputProps: {'aria-label': 'Rows per screen'},
                }}
                labelRowsPerPage={'Rows per screen:'}
                rowsPerPageOptions={tablePageRows}
                onChangeRowsPerPage={(event) => {
                  props.onChangeRowsPerPage(event);
                  setRows(event.target.value);
                }}
              />
            ),
            Body: (props) => (
              <div>
                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                    {(provided) => (
                      <div ref={provided.innerRef}>
                        <MTableBody {...props} />
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>
            ),
            Row: (props) => (
              <Draggable
                draggableId={props.data.tableData.id.toString()}
                index={props.data.tableData.id}
              >
                {(provided) => (
                  <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                  >
                    <MTableBodyRow {...props} />
                  </div>
                )}
              </Draggable>
            ),
          }}
          actions={[
            {
              icon: () => (
                <>
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot}`}
                    // disable based on role access (2699250881)
                    disabled={(windowNumber && !isCopyRowData) && !roleData?.window?.['Custom Window']?.['UD' + windowNumber]?.add}
                  >
                    <AddIcon />
                    Add Field
                  </Button>
                </>
              ),
              isFreeAction: true,
              // disable if add access is not given (2699250881)
              disabled: (windowNumber && !isCopyRowData) && !roleData?.window?.['Custom Window']?.['UD' + windowNumber]?.add,
              onClick: (event) => {
                setIsAddOpen(true);
                setFieldOperation('A');
                setOldFieldName('');
              },
            },
            (rowData) => ({
              icon: () => <EditOutlinedIcon />,
              tooltip: 'Edit',
              disabled:
                // disable if edit access is not given (2699250881)
                windowNumber && !isCopyRowData && !roleData?.window?.['Custom Window']?.['UD' + windowNumber]?.edit,
              onClick: (event, rowData) => handleEdit(rowData),
            }),
            (rowData) => ({
              icon: () => <DeleteOutlineOutlinedIcon />,
              tooltip:
                editExisting && editable?.length === 1 ?
                  'Atleast one field should exist' :
                  'Delete',
              disabled:
                // disable if delete access is not given (2699250881)
                (editExisting && editable?.length === 1) ||
                (windowNumber && !isCopyRowData &&
                  !roleData?.window?.['Custom Window']?.['UD' + windowNumber]?.delete),
              onClick: (event, rowData) => handleDelete(rowData),
            }),
          ]}
        />
        {isLoading && <PageLoader />}
        {fieldDeleteFromDBMessage && <SuccessSnackbar successMsg={fieldDeleteFromDBMessage} />}
      </div>
    </>
  );
}
